export default __webpack_public_path__ + "static/media/Influx White.ff5c05bc.png";